import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export type ButtonProps = ChakraButtonProps & {
  to?: string;
  as?: React.ElementType;
  children: ReactNode;
};

export const Button = ({ children, ...props }: ButtonProps) => {
  return (
    <ChakraButton
      size="lg"
      colorPalette="brand"
      borderRadius={'full'}
      {...props}
    >
      {children}
    </ChakraButton>
  );
};
